export default __webpack_public_path__ + "static/media/cookies.a617ed73.png";